import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import { company } from '../config/company';
import s from '../styles/legalStyles';

const TermsConditions = () => {
  return (
    <div style={s.page}>
      <SEO
        title="Regulamin"
        description={`Regulamin ${company.brand} (${company.name}, KvK ${company.kvk}).`}
      />
      <div style={s.container}>
        <h1 style={s.title}>Regulamin</h1>
        <p style={s.lastUpdated}>
          Ostatnia aktualizacja: {company.effectiveDate}
        </p>

        <article style={s.article}>
          <h2 style={s.h2}>1. Definicje</h2>
          <p>W niniejszym regulaminie obowiązują następujące definicje:</p>
          <ul style={s.list}>
            <li><strong>{company.brand}:</strong> nazwa handlowa {company.name}, zarejestrowana w holenderskim rejestrze handlowym (KvK) pod numerem {company.kvk}, z siedzibą w {company.postalCity}.</li>
            <li><strong>Strona:</strong> {company.website}</li>
            <li><strong>Odwiedzający:</strong> każda osoba fizyczna lub prawna odwiedzająca stronę.</li>
            <li><strong>Partner:</strong> zewnętrzny agent nieruchomości Nelemans, do którego kierowani są Odwiedzający.</li>
          </ul>

          <h2 style={s.h2}>2. Charakter usługi</h2>
          <p>
            {company.brand} jest platformą informacyjno-selekcyjną, oferującą wyselekcjonowany przegląd hiszpańskich
            nieruchomości znajdujących się w ofercie naszego Partnera Nelemans. <strong>Nie jesteśmy agentem
            nieruchomości</strong>, nie występujemy jako pośrednik w sensie prawnym i nie mamy relacji umownej ze
            sprzedającymi ani kupującymi nieruchomości.
          </p>
          <p>
            W przypadku zainteresowania nieruchomością zostaniesz przekierowany na stronę Partnera. Od tego momentu
            każda umowa zawierana jest między Tobą a Partnerem lub ostatecznym sprzedawcą, bez jakiegokolwiek udziału
            czy odpowiedzialności {company.brand}.
          </p>

          <h2 style={s.h2}>3. Oferta i informacje</h2>
          <p>
            Prezentowana na stronie oferta nieruchomości pochodzi z aktualizowanego na żywo źródła danych Nelemans i
            może ulec zmianie w każdej chwili. Dokładamy starań o poprawne i aktualne wyświetlanie, jednak:
          </p>
          <ul style={s.list}>
            <li>Nie gwarantujemy poprawności, kompletności ani aktualności prezentowanych informacji.</li>
            <li>Ceny, dostępność i specyfikacje mogą różnić się od rzeczywistości.</li>
            <li>Zweryfikuj wszystkie informacje u Partnera przed podjęciem decyzji o zakupie.</li>
          </ul>

          <h2 style={s.h2}>4. Odpowiedzialność</h2>
          <p>{company.brand} nie ponosi odpowiedzialności za jakiekolwiek szkody bezpośrednie lub pośrednie wynikające z:</p>
          <ul style={s.list}>
            <li>Korzystania z informacji na tej stronie lub polegania na nich.</li>
            <li>Transakcji między Odwiedzającym a Partnerem lub stronami trzecimi.</li>
            <li>Zakłóceń, błędów lub przerw w działaniu strony.</li>
            <li>Treści na zewnętrznych stronach, do których prowadzą linki.</li>
          </ul>
          <p>
            Nasza całkowita odpowiedzialność jest we wszystkich przypadkach ograniczona do kwoty faktycznie wypłaconej
            przez nasze ubezpieczenie od odpowiedzialności w danym przypadku.
          </p>

          <h2 style={s.h2}>5. Własność intelektualna</h2>
          <p>
            Cała zawartość strony (teksty, obrazy, logo, kod źródłowy, projekt) należy do {company.brand} lub jej
            licencjodawców i jest chroniona prawem autorskim. Powielanie lub ponowne wykorzystanie jest dozwolone
            wyłącznie za uprzednią pisemną zgodą.
          </p>

          <h2 style={s.h2}>6. Prywatność i pliki cookie</h2>
          <p>
            Korzystanie ze strony podlega naszej <Link style={s.link} to="/privacy">polityce prywatności</Link> oraz{' '}
            <Link style={s.link} to="/cookies">polityce plików cookie</Link>.
          </p>

          <h2 style={s.h2}>7. Prawo właściwe i spory</h2>
          <p>
            Niniejszy regulamin oraz korzystanie ze strony podlegają wyłącznie prawu holenderskiemu. Spory będą
            rozstrzygane przez właściwy sąd w okręgu Overijssel, lokalizacja Zwolle, chyba że bezwzględnie obowiązujące
            przepisy stanowią inaczej.
          </p>

          <h2 style={s.h2}>8. Zmiany</h2>
          <p>
            {company.brand} zastrzega sobie prawo do zmiany niniejszego regulaminu w dowolnym momencie. Najbardziej
            aktualna wersja jest zawsze dostępna na tej stronie.
          </p>

          <h2 style={s.h2}>9. Kontakt</h2>
          <p>
            {company.name}<br />
            {company.street}<br />
            {company.postalCity}<br />
            KvK: {company.kvk}<br />
            E-mail: <a style={s.link} href={`mailto:${company.email}`}>{company.email}</a>
          </p>
        </article>
      </div>
    </div>
  );
};

export default TermsConditions;
